<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="about">
      添加对于教学进度的记录情况，以便教学管理
    </div>
    <div class="body">
      <textarea v-model="dataForm.body" rows="8" />
    </div>
    <div class="emptyRect" />
    <div class="downButton">
      <van-button type="info" :loading="buttonLoading" square @click="onAddProgress">提交教学记录</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, MyNotify } from '@/utils/base'
import { Button } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      title: '增加教学记录',
      backurl: '/textbook/teachingProgressList',
      saveBackurl: undefined,
      id: undefined,
      buttonLoading: false,
      dataForm: {
        textBookId: undefined,
        body: undefined
      }
    }
  },

  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.saveBackurl = url
    }
    this.id = this.$route.params.id
    this.dataForm.textBookId = this.id
    this.backurl = '/textbook/teachingProgressOne/' + this.id + '?backurl=' + this.saveBackurl
  },
  methods: {
    onAddProgress() {
      if (!this.dataForm.body || this.dataForm.body.length <= 0) {
        MyNotify('info', '请输入内容')
        return
      }
      this.buttonLoading = true
      request({
        url: '/course/addTeachingProgressTextbook',
        method: 'post',
        data: this.dataForm
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '增加教学记录成功')
        this.$router.replace(this.backurl)
      })
    }
  }
}
</script>

<style scoped>
.downButton{
    position:fixed;
    z-index: 2;
    left: 0;
    bottom: 0;
    width: 100%;
}
.downButton button{
    width: 100%;
}
.emptyRect{
    height: 3em;
}
.about{
    padding: 1em 1em 0 1em;
}
.body{
    padding: 1em;
}
.body textarea{
    width: 100%;
}
</style>
